<template>
  <div v-if="hasMultipleSections" class="sensor-type-legend d-flex align-center">
    <template v-for="section in sections">
      <svg
        :key="`color-${section.type}`"
        class="legend-marker"
        :viewBox="ARROW_MARKER_VIEWBOX"
        data-testid="sensor-type-legend-color"
        aria-hidden="true"
      >
        <path
          :d="ARROW_MARKER_PATH"
          :fill="colorFor(section.type)"
          stroke="black"
          :stroke-width="ARROW_MARKER_STROKE_WIDTH"
          :transform="ARROW_MARKER_LEGEND_TRANSFORM"
        />
      </svg>
      <span
        :key="`label-${section.type}`"
        data-testid="sensor-type-legend-label"
      >
        {{ section.label }}
      </span>
      <!-- 注記はマウス操作で読ませるものなので、静止画には残さない。
           凡例は z-index を持つ要素の中に置かれるため、Vuetify の自動算出では
           周囲のパネル（panel レイヤー）に負ける。明示的に panel レイヤーを指定する -->
      <v-tooltip
        v-if="isRatSense(section.type) && !isExporting"
        :key="`notice-${section.type}`"
        bottom
        max-width="300"
        :z-index="15"
      >
        <template #activator="{ on, attrs }">
          <v-icon
            x-small
            class="ml-1"
            :aria-label="ratSenseNotice"
            data-testid="rat-sense-notice-icon"
            v-bind="attrs"
            v-on="on"
          >
            mdi-information-outline
          </v-icon>
        </template>
        <span>{{ ratSenseNotice }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import { buildSensorSections, ratSenseDetectionNotice } from '@/libs/sensorSections';
import SensorTypes, { SENSOR_TYPES } from '@/mixins/sensorTypes';

import { markerColorFor } from './markerColors';
import {
  ARROW_MARKER_PATH,
  ARROW_MARKER_VIEWBOX,
  ARROW_MARKER_STROKE_WIDTH,
  ARROW_MARKER_LEGEND_TRANSFORM,
} from './arrowMarkerShape';

export default {
  name: 'SensorTypeLegend',
  inheritAttrs: false,
  mixins: [SensorTypes],
  props: {
    sensors: {
      type: Array,
      required: true,
    },
    isExporting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sections() {
      return buildSensorSections(this.sensors, { typeNames: this.SENSOR_TYPE_NAMES });
    },
    // 種別が 1 つしか無い設置場所では色で見分ける必要が無いため、凡例ごと出さない。
    // RatSense を使っていない組織が従来どおりの見た目になるのもこの条件による。
    hasMultipleSections() {
      return this.sections.length > 1;
    },
    ratSenseNotice() {
      return ratSenseDetectionNotice(this.$i18n.locale);
    },
  },
  created() {
    this.ARROW_MARKER_PATH = ARROW_MARKER_PATH;
    this.ARROW_MARKER_VIEWBOX = ARROW_MARKER_VIEWBOX;
    this.ARROW_MARKER_STROKE_WIDTH = ARROW_MARKER_STROKE_WIDTH;
    this.ARROW_MARKER_LEGEND_TRANSFORM = ARROW_MARKER_LEGEND_TRANSFORM;
  },
  methods: {
    colorFor(sensorType) {
      return markerColorFor(sensorType);
    },
    isRatSense(sensorType) {
      return sensorType === SENSOR_TYPES.RAT_SENSE;
    },
  },
};
</script>

<style scoped>
/* 図面画像に重ねて置くため、折り返して図面を覆わないようにする */
.sensor-type-legend {
  white-space: nowrap;
  font-size: 0.75rem;
}

.legend-marker {
  margin-left: 10px;
  margin-right: 3px;
  width: 1.1rem;
  height: 1.1rem;
}
</style>
